module.exports = __webpack_public_path__ + "img/image2.58f3066d.jpg";